"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasEventCancellationWorkflow = void 0;
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasEventCancellationWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
    constructor() {
        super();
        this.outputPin = [];
        this.inputPin = [];
        this.type = Types_1.WorkflowType.EVENT_CANCELLATION;
        this.settings = this.getDefaultSettings();
        this.customProcess = {
            event_cancelled: null,
        };
        this.schema = validation_1.EventCancellationSchema;
    }
    getDefaultSettings() {
        return {
            email_campaign_id: null,
            stage_name: '',
            next_workflow_ids: {},
        };
    }
    setNextWorkflow(pin, next_workflow_id) { }
    getNextWorkflows() {
        const o = {};
        return o;
    }
    setCustomProcess(s, p) {
        if (s === 'event_cancelled') {
            this.customProcess.event_cancelled = p;
        }
    }
    getProperties() {
        return [
            {
                attribute: 'email_campaign_id',
                datasource: 'Email',
                label: 'CANCELLATION_EMAIL',
                type: 'select',
                mandatory: true,
                value: this.settings.email_campaign_id,
            },
            {
                attribute: 'stage_name',
                datasource: null,
                label: 'EVENT_CANCELLED_STAGE_NAME',
                type: 'text',
                mandatory: true,
                value: this.settings.stage_name,
            },
            {
                attribute: 'event_cancelled',
                datasource: null,
                label: 'EVENT_CANCELLED_SEQUENCE',
                type: 'process',
                mandatory: false,
                value: null,
            },
        ];
    }
}
exports.CanvasEventCancellationWorkflow = CanvasEventCancellationWorkflow;
